export const navLinks = [
  { navLinkId: "Home", scrollToId: "homeContainer" },
  { navLinkId: "Solutions", scrollToId: "solutionContainer" },
  { navLinkId: "Dermaroller", scrollToId: "dermarollerContainer" },
  { navLinkId: "LLLT", scrollToId: "llltContainer" },
];
